<template>
	<ja-modal
		ref="modal"
		class="logoutModal"
		:show="show"
		@close-modal="closeModal"
	>
		<content>
			<div class="heading-2 title">{{ $t('logout') }}</div>
			<div class="body-text-1">
				{{ $t('logoutQuestion') }}
			</div>
			<div class="button-wrapper">
				<ja-button
					class="cancel-button large transparent outlined"
					name="cancel"
					@click.native="closeModal"
				>
					<span>{{ $t('no') }}</span>
				</ja-button>
				<ja-button
					class="confirm-button large"
					name="confirm"
					:disabled="logoutAttempt"
					@click.native="logout"
				>
					<span>{{ $t('yes') }}</span>
				</ja-button>
			</div>
			<ja-close-button
				name="close"
				@click.native="closeModal"
			></ja-close-button>
		</content>
	</ja-modal>
</template>

<script>
import '../icons/arrow-right';
import '../icons/modal-close';
import Button from '../ui/Button';
import Modal from './Modal';
import CloseButton from '../ui/CloseButton';
import ModalEvents from '@/mixins/ModalEvents';

export default {
	components: {
		jaButton: Button,
		jaModal: Modal,
		jaCloseButton: CloseButton
	},
	mixins: [ModalEvents],
	data() {
		return {
			logoutAttempt: false
		};
	},
	computed: {
		show() {
			return this.$store.getters.showLogoutModal;
		}
	},
	mounted() {
		this.logoutAttempt = false;
	},
	methods: {
		closeModal() {
			this.$store.commit('closeLogoutModal');
		},
		logout() {
			this.logoutAttempt = true;
			this.closeModal();
			this.$store.commit('setLoading', true);
			this.$store.dispatch('logout');
		}
	}
};
</script>
<style lang="scss" scoped>
.logoutModal {
	z-index: 1001;
}
.heading-2 {
	margin-bottom: 24px;
}
content {
	padding: 48px;
}

.cancel-button,
.confirm-button {
	margin-top: 48px;
}

.cancel-button {
	margin-right: 16px;
}
</style>
